import React from "react";
import { Link } from "react-router-dom";
import Sideform from "../Sideform";
import ShareButtons from "../../../utility/ShareButtons";
import useServiceData from "../../../utility/useServiceData";
import FAQAccordion from "../../../utility/FAQAccordion";
import QuickNavigation from "../../../utility/serviceTemplateutility/QuickNavigation";
import CardDesign from "../../../utility/serviceTemplateutility/CardDesigntwo";
import ListDesign from "../../../utility/serviceTemplateutility/ListDesigntwo";
import WhyUs from "../../../utility/serviceTemplateutility/WhyUs";
import OurTeam from "../../homepage/OurTeam";
import Testimonials from "../../homepage/Testimonials";
import { useGlobalData } from "../../../contextApi/globalContextData";
import MultiStepForm from "../../../utility/serviceTemplateutility/MultiStepForm";

const Physiotherapy = () => {
  const serviceUrl = window.location.href;
  const data = useServiceData("Physiotherapy at Home");
  const imageUrl = data?.image_url;
  const { sectionsData } = useGlobalData();
  const faqData = [
    { heading: "Frequently Asked Questions" },
    {
      question: "How long is each physiotherapy session?",
      answer:
        "Each session typically lasts between 45 minutes to an hour, depending on the complexity of the treatment and the patient’s condition.",
    },
    {
      question: "How many sessions will I need?",
      answer:
        "The number of sessions varies based on the patient’s condition and progress. Your physiotherapist will provide a clear estimate after the initial consultation.",
    },
    {
      question: "Is home physiotherapy covered by insurance?",
      answer:
        "Many health insurance plans in Dubai cover physiotherapy services, including home-based sessions. It’s best to check with your insurance provider for specific coverage details.",
    },
    {
      question: "What equipment is required for home physiotherapy?",
      answer:
        "The equipment needed depends on the treatment plan. Commonly used items include resistance bands, exercise mats, and small weights. The physiotherapist will guide you on any additional tools needed.",
    },
  ];

  const procedures = [
    { heading: "Procedure of Physiotherapy at Home" },
    {
      para: "Physiotherapy at home follows a structured process designed to improve mobility, reduce pain, and aid recovery through personalized exercises and treatments. The treatment plan is tailored to address the patient’s unique needs.",
    },
    {
      title: "Initial Assessment",
      description:
        "The process begins with an in-depth evaluation by a licensed physiotherapist. This involves a physical examination, understanding medical history, and identifying the root cause of the issue.",
      icon: "fa-solid fa-stethoscope",
    },
    {
      title: "Customized Treatment Plan",
      description:
        "Based on the assessment, a personalized treatment plan is designed. This may include exercises, manual therapy, electrotherapy, and education about proper movement techniques.",
      icon: "fa-solid fa-notes-medical",
    },
    {
      title: "Home Visits",
      description:
        "The physiotherapist will visit the patient’s home on scheduled days to administer the treatment. They ensure that exercises are performed correctly and adjust the plan as needed.",
      icon: "fa-solid fa-house-medical",
    },
    {
      title: "Regular Monitoring and Adjustments",
      description:
        "Throughout the treatment, progress is monitored and adjustments are made to ensure optimal recovery and pain relief.",
      icon: "fa-solid fa-chart-line",
    },
  ];

  const benefits = [
    { heading: "Benefits of Physiotherapy at Home" },
    {
      para: "Opting for physiotherapy at home offers numerous advantages, particularly for patients who find it difficult to visit a clinic or prefer receiving treatment in the comfort of their home.",
    },
    {
      title: "Convenience & Comfort",
      description:
        "Receiving treatment at home eliminates the need for travel, making it an ideal solution for patients with mobility issues or busy schedules.",
      icon: "fa-solid fa-couch",
    },
    {
      title: "Personalized Care",
      description:
        "The physiotherapist provides one-on-one attention, ensuring the treatment plan is specifically designed for your unique needs and health conditions.",
      icon: "fa-solid fa-user-nurse",
    },
    {
      title: "Faster Recovery",
      description:
        "Home physiotherapy can lead to faster recovery as the treatment is tailored to your home environment, allowing you to perform exercises comfortably and consistently.",
      icon: "fa-solid fa-bolt",
    },
    {
      title: "Reduced Risk of Infection",
      description:
        "For patients recovering from surgery or with weakened immune systems, staying at home reduces exposure to potential infections found in hospitals or clinics.",
      icon: "fa-solid fa-shield-virus",
    },
    {
      title: "Time-Saving",
      description:
        "You can save time by avoiding travel and waiting at clinics. The physiotherapist comes directly to your home at a time that suits you.",
      icon: "fa-solid fa-clock",
    },
    {
      title: "Increased Consistency",
      description:
        "Patients are more likely to stick to their treatment plan when it's conducted at home, leading to better long-term results and rehabilitation outcomes.",
      icon: "fa-solid fa-check-double",
    },
  ];

  const eligibility = [
    { heading: "Eligibility for Physiotherapy at Home in Dubai" },
    {
      para: "Physiotherapy at home is suitable for a wide range of patients, but it is especially beneficial for those who face mobility issues or have chronic conditions.",
    },
    {
      title: "Post-Surgery Recovery",
      description:
        "Patients recovering from orthopedic surgeries like joint replacement or spinal surgery often benefit from physiotherapy at home.",
      icon: "fa-solid fa-hospital-user",
    },
    {
      title: "Chronic Pain Conditions",
      description:
        "Individuals suffering from chronic pain conditions like arthritis, back pain, or sciatica can greatly benefit from home-based therapy.",
      icon: "fa-solid fa-heart-pulse",
    },
    {
      title: "Neurological Conditions",
      description:
        "Patients with conditions such as stroke, multiple sclerosis, or Parkinson’s disease may need continuous physiotherapy in a comfortable and familiar environment.",
      icon: "fa-solid fa-brain",
    },
    {
      title: "Elderly Patients",
      description:
        "Older adults who experience difficulty in mobility, balance, and strength can benefit from customized physiotherapy plans delivered at home.",
      icon: "fa-solid fa-person-cane",
    },
    {
      title: "Post-Injury Rehabilitation",
      description:
        "Athletes or individuals recovering from fractures, sprains, or other injuries often find home physiotherapy essential for regaining strength and mobility.",
      icon: "fa-solid fa-dumbbell",
    },
  ];

  const preparation = [
    { heading: "Preparation for Physiotherapy at Home" },
    {
      para: "Before starting physiotherapy at home, certain preparations can help ensure that the sessions are effective and comfortable.",
    },
    {
      title: "Create a Suitable Space",
      description:
        "Set up a quiet, open area in your home where the physiotherapist can conduct sessions. It should be spacious enough to perform exercises safely.",
      icon: "fa-solid fa-house-chimney",
    },
    {
      title: "Wear Comfortable Clothing",
      description:
        "Choose loose, breathable clothing that allows for easy movement during exercises. Medical Records: Have your medical history, prescriptions, or any imaging results (X-rays, MRIs) ready for the physiotherapist’s review.",
      icon: "fa-solid fa-shirt",
    },
    {
      title: "Clear Communication",
      description:
        "Ensure that you communicate any concerns, pain points, or mobility restrictions clearly during the initial consultation to enable an accurate treatment plan.",
      icon: "fa-solid fa-comments",
    },
    {
      title: "Arrange Equipment",
      description:
        "If your treatment requires special equipment (such as exercise bands, mats, or a stationary bike), have these ready for the session.",
      icon: "fa-solid fa-dumbbell",
    },
  ];

  return (
    <>
      <title>Physiotherapy Dubai | Best Physiotherapist Near Me</title>
      <meta
        name="description"
        content="Get expert physiotherapy at home in Dubai for pain relief, mobility, &amp; injury recovery. Specialized care with Dry Cupping, Dry Needling, and Pain Management."
      />
      <meta
        name="robots"
        content="follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large"
      />
      <link
        rel="canonical"
        href="https://elitebodyhome.com/services/services/physiotherapy-dubai/"
      />
      <meta property="og:locale" content="en_US" />
      <meta property="og:type" content="article" />
      <meta
        property="og:title"
        content="Physiotherapy Dubai | Best Physiotherapist Near Me"
      />
      <meta
        property="og:description"
        content="Get expert physiotherapy at home in Dubai for pain relief, mobility, &amp; injury recovery. Specialized care with Dry Cupping, Dry Needling, and Pain Management."
      />
      <meta
        property="og:url"
        content="https://elitebodyhome.com/services/physiotherapy-dubai/"
      />
      <meta property="og:site_name" content="elitebodyhome.com" />
      <meta property="og:updated_time" content="2024-12-30T10:42:07+00:00" />
      <meta
        property="og:image"
        content="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-69.jpg"
      />
      <meta
        property="og:image:secure_url"
        content="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-69.jpg"
      />
      <meta property="og:image:width" content="1254" />
      <meta property="og:image:height" content="700" />
      <meta property="og:image:alt" content="Physiotherapy Dubai" />
      <meta property="og:image:type" content="image/jpeg" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:title"
        content="Physiotherapy Dubai | Best Physiotherapist Near Me"
      />
      <meta
        name="twitter:description"
        content="Get expert physiotherapy at home in Dubai for pain relief, mobility, &amp; injury recovery. Specialized care with Dry Cupping, Dry Needling, and Pain Management."
      />
      <meta
        name="twitter:image"
        content="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-69.jpg"
      />
      <div className="min-vh-100 font-sans text-dark mb-5 mx-3">
        <section className="overflow-hidden ">
          <div className="position-relative mb-3">
            <img
              src={imageUrl}
              alt="weight reduction dubai"
              className="img-fluid w-100 rounded mt-2 "
              style={{
                height: "500px",
                objectFit: "cover",
                objectPosition: "top",
                border: "2px solid #c69933",
                borderRadius: "100px",
              }}
            />
          </div>
        </section>
        <div className="d-flex gap-4  w-100 ">
          <div
            className=" rounded-4 p-2 bg-white flex-grow-1 "
            style={{
              width: "65%",
              border: "2px solid #c69933",
            }}
          >
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="/home">Home</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Services
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Physiotherapy Dubai
                </li>
              </ol>
            </nav>
            <div>
              <h1
                className="display-4 fw-semibold"
                style={{
                  color: "#c69933",
                }}
              >
                Physiotherapy at Home Dubai
              </h1>
            </div>
            <QuickNavigation />
            <div>
              <h3 className="title">
                <span className="">Expert Physiotherapy, Right at Your</span>
                <span className="">
                  <span className="">Doorstep</span>
                </span>
              </h3>
            </div>
            <div>
              <p>
                Experience the convenience of professional Physiotherapy at Home
                in Dubai with Elite Body Home. Our licensed physiotherapists
                bring personalized care directly to your doorstep, ensuring you
                receive the same high-quality treatment in the comfort of your
                home. Whether you’re recovering from an injury, managing chronic
                pain, or seeking rehabilitation, we tailor every session to meet
                your unique needs. Skip the hassle of travel and appointments –
                let our experts help you restore mobility, improve strength, and
                achieve optimal health without leaving your home.
              </p>
            </div>
            <div id="procedures">
              <CardDesign carditems={procedures} />
            </div>
            <div id="benefits">
              <ListDesign listitems={benefits} />
            </div>

            <div id="eligibility">
              <CardDesign carditems={eligibility} />
            </div>

            <div id="preparations">
              <ListDesign listitems={preparation} />
            </div>

            <WhyUs language="en" />
            <OurTeam data={sectionsData["Professional"]} />
            <Testimonials data={sectionsData["Success Stories"]} />
            <FAQAccordion faqData={faqData} />
            <ShareButtons url={serviceUrl} />
          </div>
          <MultiStepForm />
        </div>
      </div>
    </>
  );
};

export default Physiotherapy;
